const Default = (props) => {
  const { img, uid, children } = props;

  return (
    <div
      id={`${uid}`}
      style={{
        borderRadius: 10,
        overflow: "hidden",
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: 200,
        aspectRatio: 777 / 1035,
      }}
    >
      {children}
    </div>
  );
};

export default Default;
